export default __webpack_public_path__ + "static/media/png.78dde2ad.svg";